import { Fragment } from "react";

import ReactDOM from "react-dom";

import Backdrop from "./Backdrop/Backdrop"

import videoSrc from "../assets/loading/loading_skull_300.mp4";

import classes from "./LoadingSpinner.module.css";

const LoadingOverlay = () => {
  return (
    <div className={classes.loading_icon_wrapper}>
      <video
        className={classes.loading_icon}
        autoPlay
        loop
        muted
        playsInline
      >
  
        {/* MP4 format for fallback */}
        <source
          src={videoSrc}
          type="video/mp4"
        />     
      </video>
    </div>
    
  );
};


const portalElement = document.getElementById("overlays");

const LoadingSpinner = (props) => {
  return (
    <Fragment>
      {ReactDOM.createPortal(
        <Backdrop onClose={props.onClose} />,
        portalElement
      )}
      {ReactDOM.createPortal(
        <LoadingOverlay>{props.children}</LoadingOverlay>,
        portalElement
      )}
    </Fragment>
  );
};

export default LoadingSpinner;
